/**
 * 导出API模块
 * 必须加上注释
 */
import * as baseApiModules from './apiModules/baseApi'; // 基础模块接口
import * as aboutApiModules from './apiModules/aboutApi'; // 关于我模块接口
import * as vocationApiModules from './apiModules/vocationApi'; // 假日出发模块接口
import * as lessonApiModules from './apiModules/lessonApi'; // 名猫讲堂模块接口
import * as raffleApiModules from './apiModules/raffleApi'; // 抽奖答题模块接口
import * as paymentApiModules from './apiModules/paymentApi'; // 支付模块接口
import * as liveBroadcastApiModules from './apiModules/liveBroadcast'; // 直播模块接口
import * as guideApiModules from './apiModules/guideApi'; // 导览模块接口

export {
    baseApiModules,
    vocationApiModules,
    lessonApiModules,
    raffleApiModules,
    aboutApiModules,
    paymentApiModules,
    liveBroadcastApiModules,
    guideApiModules
}




// WEBPACK FOOTER //
// ./src/api/index.js